import Button from 'components/ui/Button/Button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { stripTags } from 'utils/shared/utils';
import ScreenshotSupport from '../../ScreenshotSupport';
import MaximizeModal from '../../MaximizeModal';
import { checkAHAVI } from 'utils/utils';
import useDraggableModal from 'hooks/useDraggableModal';

interface NotesModalProps {
  close: () => void;
  onSave: (desc: string) => void;
  freeText: string;
}

const NotesModal: FC<NotesModalProps> = ({ close, onSave, freeText, ...props }) => {
  const { t } = useTranslation();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const [desc, setDesc] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);

  useEffect(() => {
    if (freeText) {
      setDesc(freeText);
    }
  }, [freeText]);

  const onClickSave = () => {
    setIsSubmitted(true);
    if (desc && desc.length < 3) {
      return;
    }

    close();
    onSave(stripTags(desc));
  };

  return (
    <Fragment>
      {createPortal(
        <div className="modal-overlay modal-overlay-top modal-maximizable" ref={modalOverlayRef}>
          <div ref={modalRef} className="modal active" style={modalStyle}>
            <div
              className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
              {...dragHandleProps}
            >
              <div className="title">{t('proposal.edit')}</div>
              <div data-no-drag="true">
                <ScreenshotSupport />
                <MaximizeModal modalOverlayRef={modalOverlayRef} />
                <FontAwesomeIcon icon={faTimes} onClick={close} />
              </div>
            </div>
            <div className="modal-content">
              <div className={'form-group' + (isSubmitted && desc.length < 3 ? ' is-invalid' : '')}>
                <label>{t('notes')}</label>
                <textarea
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  className="form-control form-control-textarea"
                  style={{ direction: checkAHAVI(desc) ? 'rtl' : 'ltr', height: 90 }}
                  rows={3}
                />
                {isSubmitted && desc.length < 3 && (
                  <div className="form-invalid-text">{t('validation.required')}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <Button className="btn btn-default" title={t('close')} onClick={close} />

              <Button className="btn btn-primary" title={t('save')} onClick={onClickSave} />
            </div>
          </div>
        </div>,
        document.body
      )}
    </Fragment>
  );
};

export default NotesModal;
